import { Navigate } from "react-router";
import { useLocation } from "react-router";

/**
 * Same as the regular Navigate component, but keeps the search params intact after redirecting
 */
export default function HubNavigate(props) {
  const location = useLocation()

  return <Navigate {...props} to={`${props.to}${location.search}`} />;
}
